import { render } from "./CHECK.vue?vue&type=template&id=5cc604af&scoped=true"
import script from "./CHECK.vue?vue&type=script&lang=js"
export * from "./CHECK.vue?vue&type=script&lang=js"

import "./CHECK.vue?vue&type=style&index=0&id=5cc604af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc604af"]])

export default __exports__